import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW9011Model } from './kymw9011.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { ActivatedRoute, Router } from '@angular/router';
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { PasswordResetService } from './api-services/password-reset.service';

/**
 * パスワード再設定入力画面
 *
 * @export KYMW9011Component
 * @class KYMW9011Component
 */
@Component({
  selector: 'app-kymw9011',
  templateUrl: 'kymw9011.component.html',
  styleUrls: ['kymw9011.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9011Component extends PlessViewHelperSub implements OnInit {

  model: KYMW9011Model = new KYMW9011Model();

  @ViewChild('txti_NewPassword', { static: true }) txti_NewPassword: ElementRef;
  @ViewChild('txti_NewPasswordCheck', { static: true }) txti_NewPasswordCheck: ElementRef;

  /** パスワード表示アイコン */
  faEye = faEye;
  /** パスワード非表示アイコン */
  faEyeSlash = faEyeSlash;
  /** アイコン変更用（新しいパスワード） 初期値：非表示 */
  iconEyeDisp: any = this.faEyeSlash;
  /** アイコン変更用（新しいパスワード(確認)） 初期値：非表示 */
  iconEyeDisp_check: any = this.faEyeSlash;
  /** パスワード表示制御用 （新しいパスワード）初期値：非表示(●) */
  isPasswordVisible: boolean = <boolean>false;
  /** パスワード表示制御用 （新しいパスワード(確認)）初期値：非表示(●) */
  isPasswordVisible_check: boolean = <boolean>false;

  /**
   *Creates an instance of KYMW9011Component.
   * @param {KYMW00Model} kymw00Model
   * @param {Router} router
   * @param {PlessDialogServiceSub} dialogService
   * @memberof KYMW9011Component
   */
  constructor(
    public kymw00Model: KYMW00Model,
    private router: Router,
    private dialogService: PlessDialogServiceSub,
    private passwordResetService: PasswordResetService,
    private route: ActivatedRoute,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW9011Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9011';
    this.model.kYMW9011Component = this;
  }

  /**
   * 戻るボタンを押した時のイベント
   * 
   * @memberof KYMW9011Component
   */
  public eventReturnHanler(): void {
    this.router.navigate(['/kymw/9007']);
  }

  /**
   * 目アイコン押下時
   * フォーカス制御、アイコン変更、テキスト表示制御
   * 
   * @param event 
   * @param btnCheck 1:新しいパスワード、2:新しいパスワード(確認)
   */
  public eventEye_MouseDownHandler(event: MouseEvent, btnCheck: any) {
    event.preventDefault();
    
    if (btnCheck === 1) {
      // 「新しいパスワード」入力欄の時
      this.txti_NewPassword.nativeElement.focus();
      if (this.isPasswordVisible) {
        this.iconEyeDisp = this.faEyeSlash;
      } else {
        this.iconEyeDisp = this.faEye;
      }
      this.isPasswordVisible = !this.isPasswordVisible;
      
    } else {
      // 「新しいパスワード(確認)」入力欄の時
      this.txti_NewPasswordCheck.nativeElement.focus();
      if (this.isPasswordVisible_check) {
        this.iconEyeDisp_check = this.faEyeSlash;
      } else {
        this.iconEyeDisp_check = this.faEye;
      }
      this.isPasswordVisible_check = !this.isPasswordVisible_check;
    }
  }

  /**
   * 更新ボタン押下時
   * Cognitoの機能でパスワードの再設定処理を行う
   */
  public eventUpdateHandler(): void {
    // 必須入力値のチェック
    if(PlessViewUtilsSub.isEmpty(this.model.confirmCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['認証コード']);
      return;
    }
    if(PlessViewUtilsSub.isEmpty(this.model.newPassword)) {
      this.dialogService.openAlertGetMessage('W0001', ['新しいパスワード']);
      return;
    }
    if(PlessViewUtilsSub.isEmpty(this.model.newPasswordCheck)) {
      this.dialogService.openAlertGetMessage('W0001', ['新しいパスワード(確認)']);
      return;
    }

    // 新しいパスワードと新しいパスワード(確認)が一致するかのチェック
    if(this.model.newPassword !== this.model.newPasswordCheck) {
      this.dialogService.openAlertGetMessage('W0058');
      return;
    }

    // 確認アラート
    this.dialogService.openAlertGetMessage('Q0194', [], (closeDetail)=>{
      if (closeDetail === PlessAlert.Yes) {
        // パスワード再設定処理実行
        const vo = {
          ConfirmCode: this.model.confirmCode,
          NewPassword: this.model.newPassword};
        this.passwordResetService.execute(this.model, vo, () => {
          this.dialogService.openAlertGetMessage('I0505', ['パスワード'], (closeDetail)=>{
            if(closeDetail === PlessAlert.Yes) {
              this.router.navigate(['login']);
            }
          });
        });
      }else {
        return;
      }
    });
  }
}
